import React from "react"
import { graphql } from 'gatsby'
import { GatsbyImage, getImage  } from "gatsby-plugin-image"
import styled from 'styled-components'

import ConditionalLayout from "../components/conditional-layout"
import Seo from "../components/seo"

const TeamMemberTemplate = ({ data: { teamMember } }) =>  {

  const teamImage = getImage(teamMember.TeamMemberJobTitle.tmModalImage.localFile.childImageSharp.gatsbyImageData)

  return(
    <ConditionalLayout>
      <Seo 
        title={teamMember.SEOmeta.metaTitle} 
        description={teamMember.SEOmeta.metaDescription}
        keywords={teamMember.SEOmeta.metaKeywords}
        ogTitle={teamMember.SEOmeta.ogTitle} 
        ogDescription={teamMember.SEOmeta.ogDescription}
        ogImage={teamMember.SEOmeta.ogImage.localFile.childImageSharp.fluid}
        twitterTitle={teamMember.SEOmeta.twitterTitle} 
        twitterDescription={teamMember.SEOmeta.twitterDescription}
        twitterImage={teamMember.SEOmeta.twitterImage.localFile.childImageSharp.fluid}
        />
        <TeamMain>
          <div class="flex-row">
            <div class="left-col">
              <GatsbyImage image={teamImage} alt={teamMember.title} />
            </div>
            <div class="right-col">
              <header>
                <h1>{teamMember.title}</h1>
                <h2>{teamMember.TeamMemberJobTitle.tmJobTitle}</h2>
              </header>
              <hr/>
              <div dangerouslySetInnerHTML={{ __html: teamMember.content }} />
            </div>
          </div>
        </TeamMain>
    </ConditionalLayout>
  )
  
}

const TeamMain = styled.article`
  .flex-row {
    display: flex;
    max-width: 1160px;
    width: 100%;
    margin: 0 auto;
    .left-col {
      max-width: 400px;
      width: 100%;
    }
    .right-col {
      max-width: 760px;
      width: 100%;
      padding-left: 40px;
    }
    header {
      h1 {
        font-size: 60px;
        margin-top: 40px;
        margin-bottom: 0;
        font-weight: 700;
      }
      h2 {
        font-size: 18px;
        text-transform: uppercase;
        color: #C44C4A;
        margin-top: 10px;
        margin-bottom: 0px;
      }
    }
    hr {
      margin-top: 35px;
      margin-bottom: 35px;
    }
    p {
      font-family: "Work Sans";
      font-size: 18px;
      font-weight: 400;
      line-height: 1.4;
      color: rgb(119, 124, 124);
      margin-bottom: 0px;
    }
  }
  @media(max-width:1290px) {
    .flex-row {
      max-width: 760px;
      .left-col {
        max-width: 250px;
      }
      .right-col {
        max-width: 510px;
      }
      header {
        h1 {
          font-size: 34px;
          margin-top: 20px;
        }
        h2 {
          font-size: 14px;
        }
      }
      p {
        font-size: 14px;
      }
    }
  }
  @media(max-width:890px) {
    .flex-row {
      max-width: 560px;
      .left-col {
        max-width: 200px;
      }
      .right-col {
        max-width: 360px;
        padding-left: 20px;
      }
      header {
        h1 {
          font-size: 28px;
          margin-top: 0px;
        }
        h2 {
          font-size: 12px;
        }
      }
      hr {
        margin-top: 15px;
        margin-bottom: 15px;
      }
      p {
        font-size: 14px;
      }
    }
  }
  @media(max-width:767px) {
    .flex-row {
      max-width: 400px;
      width: 100%;
      padding-top: 20px;
      flex-wrap: wrap;
      .left-col {
        max-width: 100%;
        order: 2;
      }
      .right-col {
        max-width: 100%;
        order: 1;
        padding-left: 0px;
        padding-bottom: 20px;
      }
      header {
        h1 {
          font-size: 20px;
        }
        h2 {
          font-size: 10px;
        }
      }
      p {
        font-size: 12px;
      }
    }
  }
`

export default TeamMemberTemplate

export const pageQuery = graphql`
  query TeamMemberById(
    # these variables are passed in via createPage.pageContext in gatsby-node.js
    $id: String!
  ) {
    # selecting all teammembers minus the current member
    allTeamMembers: allWpWlTeamMember(sort: {fields: date, order: DESC}, filter: {id: {ne: $id}}) {
      edges {
        node {
          title
          slug
          featuredImage {
              node {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 770
                      placeholder: BLURRED
                      formats: [AUTO, WEBP, AVIF]
                    )
                  }
                }
              }
            }
          TeamMemberJobTitle {
              tmJobTitle
              tmModalImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 400
                      placeholder: BLURRED
                      formats: [AUTO, WEBP, AVIF]
                    )
                  }
                }
              }
          }
        }
      }
    }
    # selecting the current team member by id
    teamMember: wpWlTeamMember(id: { eq: $id }) {
      id
      title
      content
      date(formatString: "MMMM DD, YYYY")
      SEOmeta {
        metaTitle
        metaDescription
        metaKeywords
        ogTitle
        ogDescription
        ogImage {
          localFile {
            childImageSharp {
              fluid(maxWidth: 1320, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        twitterTitle
        twitterDescription
        twitterImage {
          localFile {
            childImageSharp {
              fluid(maxWidth: 1320, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
      TeamMemberJobTitle {
        tmJobTitle
        tmModalImage {
          localFile {
            childImageSharp {
              gatsbyImageData(
                width: 400
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
      }
      TeamMemberPageBuilder {
        tmPageBuilder {
          __typename
          ... on WpWLTeamMember_Teammemberpagebuilder_TmPageBuilder_TmFullWidthImage {
            fieldGroupName
            tmFullImage {
              title
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 1320
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
          }
          ... on WpWLTeamMember_Teammemberpagebuilder_TmPageBuilder_TmTwoThirdsOneThirdImage {
            fieldGroupName
            tmTwoThirdsContent
            tmOneThirdImage {
              title
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 800
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
          }
          ... on WpWLTeamMember_Teammemberpagebuilder_TmPageBuilder_TmQuoteSection {
            fieldGroupName
            tmQuoteContent
            tmQuoteMeta
            tmQuoteSectionTitle
          }
        }
      }
    }
  }
`